import getUserRatingLabelIntlId from '@/scopes/common/components/utils/getUserRatingLabelIntlId'
import { space, tok } from '@sunwebgroup/ui-components'
import { Badge, Rating, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { useIntl } from '../../../../../../../../intl'

interface ScoreRatingsProps extends React.HTMLAttributes<HTMLSpanElement> {
  rating: number
  userRating: number | undefined
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${tok('primitives_color_neutral_600')};
  gap: ${space('primitives_space_8')};
  order: -1; // Change visual order, but keep semantic order
`

const UserRatingWrapper = styled.div`
  margin-left: auto !important;
  ${Badge} {
    margin-left: ${space('primitives_space_8')};
  }
`

export function UserRating({ userRating }: { userRating: number | undefined }) {
  const intl = useIntl()

  if (userRating === undefined || userRating <= 0) {
    return null
  }

  return (
    <UserRatingWrapper>
      <Typography variant="body-s-regular-snug">{intl.formatMessage({ id: getUserRatingLabelIntlId(userRating) })}</Typography>
      <Badge>{userRating}</Badge>
    </UserRatingWrapper>
  )
}

export function ScoreRatings({ rating, userRating, ...attributes }: ScoreRatingsProps) {
  return (
    <Wrapper {...attributes}>
      <Rating rating={rating} />
      <UserRating userRating={userRating} />
    </Wrapper>
  )
}
